import { useEffect, useRef, useState } from "react";

export function useEntranceAnimation(options?: {
  threshold?: number;
  rootMargin?: string;
  sectionIndex?: number;
}) {
  const { threshold = 0.12, rootMargin, sectionIndex = 0 } = options || {};

  // Progressive rootMargin for flowing staged effect:
  // earlier sections trigger sooner (smaller bottom offset), later sections trigger deeper
  const progressiveRootMargin =
    rootMargin || `0px 0px -${50 + sectionIndex * 90}px 0px`;

  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) {
      setIsVisible(true);
      return;
    }

    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold, rootMargin: progressiveRootMargin }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, progressiveRootMargin]);

  return { ref, isVisible };
}